import * as React from 'react';
import { SmartToyOutlined } from '@mui/icons-material';

const SmartToyGradient = () => (
  <>
    <svg width={0} height={0}>
      <defs>
        <linearGradient id="gradient">
          <stop offset="0%" stopColor="#0D9488" />
          <stop offset="100%" stopColor="#14B8A6" />
        </linearGradient>
      </defs>
    </svg>
    <SmartToyOutlined
      sx={{ fill: 'url(#gradient)', fontSize:'6.25rem'}}
    />
  </>
);

export default SmartToyGradient;
